import React from 'react';
import Combainbottom from '../Components/Combainbottom/Combainbottom';
import Combaintop from '../Components/Combaintop/Top';
import BillingInfo from '../Components/Checkout/CheckoutComponent';
import Breadcrumbs from '../Components/banner/New-banner';
function Checks() {
  return (
    <>
      <Combaintop />
      <Breadcrumbs />
      <BillingInfo />
      <Combainbottom />
    </>

  );
}

export default Checks;